// extracted by mini-css-extract-plugin
export default {"header":"j2eQW5LO","addCredits":"o9PDGaiM","loadMore":"Tz1VncD2","creditLink":"MyK47eMX","credit":"_20oh07M7","avatar":"_34hFFElb","wrapper":"NcVxQfGB","displayname":"_21P75e6g"};